import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import moment from "moment";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Button from "../../Components/Button/Button";
import { blogData } from "../../redux/blogs/blogSlice";
import "./AllBlogs.css";
import "./TableStyle.css";
import CustomDropdown from "../../Components/CustomDropdown/CustomDropdown.jsx"
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import BlogFilterSlider from "../../Components/FilterSlider/BlogsFilter/BlogsFilter.js";
import {
  getAllBlogs,
  getBlogById,
  deleteBlog,
  updateBlog,
  duplicateBlog,
  makeBlogActiveInactive,
  clearBlogSliceStates,
  clearBlogSliceData,
} from "../../redux/blogs/blogSlice";
import DropActions from "../../Components/DropActions/DropActions.jsx";
import Image from "../../Components/Image/Image";
import Cookies from "js-cookie";
import LogoutPopup from "../../Components/Popups/LogoutPopup/LogoutPopup.jsx";
import BlogDashboardMenu from "../../Layouts/Menu/BlogDashboardManagement/BlogDashboardMenu.js";
import EditBlogPopup from "../../Components/Popups/EditBlogPopup/EditBlogPopup.jsx";
import ComponentLoader from "../../Components/loaders/ComponentLoader/ComponentLoader.jsx";
import BlogPreview from "../../Components/Popups/BlogPreview/BlogPreviewPopup.js";
import UpdateCreatedOnPopup from "../../Components/Popups/UpdateCreateOnPopup/UpdateCreatedOnPopup.jsx";

const BlogUrl = () => {
  const roles = Cookies.get("roles");
    const data = Cookies.get('loginData')
        ? JSON.parse(Cookies.get('loginData'))
        : null
  const SPECIAL_ORG_ID = "52c3b93c-59ba-44e7-8e99-bd5fc889b68f";
  const blogBaseUrl =
    data?.organizationId === SPECIAL_ORG_ID
      ? "https://tetr.com"
      : "https://mastersunion.org";
  const [isAdmin, setIsAdmin] = useState(false);
  useEffect(() => {
    if (roles) {
      let tempRole = JSON.parse(roles);
      setIsAdmin(tempRole?.includes("admin"));
    }
  }, [roles]);
  const {
    isBlogSliceFetching,
    isBlogSliceFetchingSmall,
    isBlogEditSliceSuccess,
    isBlogDuplicatedSliceSucess,
    isBlogSliceError,
    blogSliceErrorMessage,
    blogSliceSuccessMessage,
    isBlogActiveInactiveSuccess,
    isBlogSliceSuccess,
    isBlogDeleteSliceSuccess,
    allBlogs,
    blogCount,
    blogDetail,
  } = useSelector((state) => state.blog);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedBlogId, setSelectedBlogId] = useState([]);
  const [selectedBlog, setSelectedBlog] = useState([]);
  const [isDropAction, setIsDropAction] = useState(false);
  const [deletePopup, setDeletePopup] = useState(false);
  const [statusPopup,setStatusPopup]=useState(false)
  const [editBlogPopup, setEditBlogPopup] = useState(false);
  const [previewPopup,setPreviewPopup]=useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isFilterSlider, setIsFilterSlider] = useState(false);
  const [blogId, setBlogId] = useState(null);
  const [createdOnPopup , setCreatedOnPopup] = useState(false);
  const intialFilter = {
    statusType:"all",
    fromDate:moment("2019-01-01").format("YYYY-MM-DD"),
    toDate:moment().format("YYYY-MM-DD"),
  
    blogType:""
  }
   const [filters, setFilters] = useState(intialFilter);
  // const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const [isPerPageDrop, setIsPerPageDrop] = useState(false);
  const [perPageDropName, setPerPageDropName] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const searchParams = useSearchParams();

  const toggleActionDropdown = (rowId, blog) => {
    setIsDropAction(isDropAction === rowId ? false : rowId);
    setSelectedBlogId(rowId);
    setSelectedBlog(blog);
    setBlogId(blog.id)
    console.log(blog);
    

  };

  const onChangePerPage = (obj) => {
    setPerPageDropName(obj.id);
    // setIsAllChecked(false);
    // setSelectedApplicants([]);
  };
  const dropActionOptions = [
    { label: "Delete Blog", onClick: () => setDeletePopup(true) },
    {
      label: "Edit Blog",
      onClick: () => {
        setEditBlogPopup(true);
      },
    },
    {
      label: "Preview Blog",
      onClick: () => {
        // setPreviewPopup(true);
        navigate(`/blog-details?id=${blogId}`);

      },
    },
      {
        label: "Change Status",
        onClick: () => setStatusPopup(true)
      },
      {
        label: "Change CreatedOn Date",
        onClick: () => setCreatedOnPopup(true)
      },
      // {
      //   label: "Duplicate Blog", // New option for duplicating a blog
      //   onClick: () => {
      //     handleDuplicate(selectedBlogId);
      //   },
      // }
      
  ];
const BlogsRightMenuoption=[
  () => (
    <CustomDropdown
      className={"current"}
      dropName={perPageDropName}
      options={[
        { name: "10", id: 10 },
        { name: "20", id: 20 },
        { name: "30", id: 30 },
        { name: "40", id: 40 },
        { name: "50", id: 50 },
        { name: "Max", id: blogCount },
      ]}
      isActive={isPerPageDrop}
      setIsActive={setIsPerPageDrop}
      onSelect={onChangePerPage}
    />
  ),
  // ()=>(
  //   <Button
  //       className={"iconButton"}
  //       src={"https://cdn.mastersunion.org/assets/dinero/filter.svg"}
  //       name={"Filters"}
  //       onClick={() => {
  //         setIsFilterSlider(!isFilterSlider);
  //       } } />)
    ]
  const BlogSearchHandler = (searchValue) => {
    const keywords = searchValue.split(",").map((keyword) => keyword.trim());
    setCurrentPage(1);
    setSearchQuery(keywords);
  };
  const loadMore = () => {
    dispatch(
      getAllBlogs({
        perPageCount: perPageDropName,
        pageNumber: currentPage + 1,
        searchValue: searchQuery,
        filters:filters
      })
    );
    setCurrentPage(currentPage + 1);
   
  };
  const handleStatusPopup = (blogId) => {
    setSelectedBlogId(blogId);
    setStatusPopup(true);
  };

  const clearSearch = () => {
    setSearchQuery("");
    setCurrentPage(1);
  };

  const handleDelete = (blogId) => {
    console.log("del", blogId);
    let obj = {
      id: selectedBlogId,
      userId : data ? data.id : ""
    };
    dispatch(deleteBlog(obj));
  };

  const handleStatus= (blogId,status) => {
    console.log("status", blogId,status);
    let obj = {
      id: selectedBlogId,
      status: !selectedBlog?.blog_isActive,
      userId : data ? data.id : ""

    };
    dispatch(makeBlogActiveInactive(obj));
  };
  const handleEditPopup = (obj) => {
    console.log("edit", obj);
    dispatch(updateBlog(obj));
  };
  const handleDuplicate = (blogId) => {
    console.log("Duplicate blog with ID:", blogId);
    let obj={
      blogId:blogId
    }
    dispatch(duplicateBlog(obj));
  };
  const readMore = (id) => {
    console.log("id", id);
    navigate(`/blog-details?id=${id}`);
  };

  useEffect(() => {
    let obj = {
      perPageCount: perPageDropName,
      searchValue: searchQuery,
      pageNumber: 1,
      filters:filters
    };
    console.log("obj",obj)
    dispatch(getAllBlogs(obj));
    return () => {
      dispatch(clearBlogSliceData())
      dispatch(clearBlogSliceStates())
    }
  }, [searchQuery,filters,perPageDropName]);

  const successToast = () => {
    toast.success(blogSliceSuccessMessage, {
      // position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 3000, // Close the toast after 3 seconds
      hideProgressBar: false, // Display progress bar
      pauseOnHover: true, // Pause the timer when hovering over the toast
    });
  };

  const errorToast = () => {
    toast.error(blogSliceErrorMessage, {
      // position: toast.POSITION.BOTTOM_CENTER,
      autoClose: 3000, // Close the toast after 3 seconds
      hideProgressBar: false, // Display progress bar
      pauseOnHover: true, // Pause the timer when hovering over the toast
    });
  };
  useEffect(() => {
    if (isBlogEditSliceSuccess) {
      successToast();
      // setDeletePopup(false);
      setEditBlogPopup(false);
      setCreatedOnPopup(false)
    }
    return()=>{
      dispatch(clearBlogSliceStates())
    }
  }, [isBlogEditSliceSuccess]);

  useEffect(() => {
    if (isBlogDuplicatedSliceSucess) {
      successToast();
     
    }
    return()=>{
      dispatch(clearBlogSliceStates())
    }
  }, [isBlogDuplicatedSliceSucess]);


  useEffect(() => {
    if (isBlogDeleteSliceSuccess) {
      successToast();
      setDeletePopup(false);
      // setEditBlogPopup(false);
    }
    return()=>{
      dispatch(clearBlogSliceStates())
    }
  }, [isBlogDeleteSliceSuccess]);
  
  useEffect(() => {
    if (isBlogActiveInactiveSuccess) {
      successToast();
     setStatusPopup(false)
      // setEditBlogPopup(false);
    }
    return()=>{
      dispatch(clearBlogSliceStates())
    }
  }, [isBlogActiveInactiveSuccess]);
  useEffect(() => {
    if (isBlogSliceError) {
      errorToast();
    }
  }, [isBlogSliceError]);
  return (
    <>
    
      <ToastContainer />
     
      {/* <BlogFilterSlider
        isActive={isFilterSlider}
        setIsActive={setIsFilterSlider}
        setFilters={setFilters}
      /> */}



      
      {deletePopup && (
        <LogoutPopup
          showActive={deletePopup}
          userId={selectedBlogId}
          message={"Are you sure you want to delete this Blog?"}
          onCancel={() => setDeletePopup(false)}
          onAllow={handleDelete}
          isPopupFetching={isBlogSliceFetchingSmall}
        />
      )}
      {statusPopup && (
        <LogoutPopup
          showActive={statusPopup}
          userId={selectedBlogId}
          message={"Are you sure  change status of Blog?"}
          onCancel={() => setStatusPopup(false)}
           onAllow={handleStatus}
  
          isPopupFetching={isBlogSliceFetchingSmall}
        />
      )}

 
      <BlogDashboardMenu
        searchFunction={BlogSearchHandler}
        clearSearch={clearSearch}
        currentCount={allBlogs.length}
        // totalCount={allBlogs.length}
        totalCount={blogCount && blogCount}
        BlogsRightMenuoption={BlogsRightMenuoption}
        onClickCreateBlog={()=>navigate(`/create-blog`)}
      />
      <div className="wrapperBox doubleMenu">
     
        {isBlogSliceFetching && allBlogs?.length ===0 &&  <ComponentLoader />}
        <div className="tableWrapper MsTbScrollwrap wrapWithButton checkboxTable noIconTable blogsUrlTable">
          <table className="darkHeaderTable">
            <thead>
              <tr>
              <th>
                  <div className="tableHeading">
                    <img src="/assets/svg/teacher.svg" alt="" />
                    S. No.
                  </div>
                </th>
                
                <th>
                  <div className="tableHeading">
                    <img src="/assets/svg/user.svg" alt="" />
                    Blog Title
                  </div>
                </th>
               
         
                  <th>
                    <div className="tableHeading">
                      <img src="/assets/svg/user.svg" alt="" />
                      URL
                    </div>
                  </th>
            
              </tr>
            </thead>
            <tbody>
              {allBlogs?.map((blog, index) => (
                <tr key={blog?.id}>
                   <td>
                    <div className="tableData">
                     {index + 1}
                    </div>
                  </td>
           
                  <td>
                    <div
                      className="tableData "
                     
                    >
                      {blog?.blog_Title}
                    </div>
                  </td>
             

                  <td>
                  <div className="tableData">
                   {/* {blog?.user[0]?.firstName }{" "}{blog?.user[0]?.lastName} */}
                   <div className="tableData textBlue pointer" onClick={()=> window.open(`${blogBaseUrl}/blog/${blog.slug}`, "_blank")} >{`${blogBaseUrl}/blog/${blog.slug}`}</div>

                   </div>
                  </td>
       
                </tr>
              ))}
              
              {allBlogs?.length === 0 && !isBlogSliceFetching && (
                <tr>
                  <td colSpan={"11"}>
                    <span className="noData">
                      <img
                        src={
                          "https://cdn.mastersunion.org/assets/imgV2/noDataDineroNew2.png"
                        }
                        alt=""
                      />
                    </span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          
        </div>
        {allBlogs?.length !== blogCount && (
          <div className="loadMoreWrapper">
            <Button
              isWaiting={
                allBlogs?.length > 0 &&
                isBlogSliceFetchingSmall
              }
              onClick={loadMore}
              className={"BlueFillButton"}
              name={"Load More"}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default BlogUrl;
